
<template>
 <BtnFlotWA />
  <section> <Navbar /> </section>
  <section> <img class="bannerestatico" src="@/assets/banners/catalogo/maquillaje_banner.png "> </section>
  
  <section class="catalog-container">
    <aside class="sidebar">
      <!-- CATEGORÍAS EN SIDEBAR -->
      <div class="filter-section">
        <h4 class="h4"> CATEGORIAS </h4>
        <label><input type="radio" value="Todos" v-model="selectedCategory" > Todos </label>
        <label><input type="radio" value="Lippies" v-model="selectedCategory" > Lippies </label>
        <label><input type="radio" value="Rubores" v-model="selectedCategory" > Rubores </label>
        <label><input type="radio" value="Correctores" v-model="selectedCategory" > Correctores </label>
        <label><input type="radio" value="Fijadores" v-model="selectedCategory" > Fijadores </label>
        <label><input type="radio" value="Bases" v-model="selectedCategory" > Bases </label>
        <label><input type="radio" value="Iluminadores" v-model="selectedCategory" > Iluminadores </label>
        <label><input type="radio" value="Bronzers" v-model="selectedCategory" > Bronzers </label>
        <label><input type="radio" value="Contornos" v-model="selectedCategory" > Contornos </label>
        <label><input type="radio" value="Primers" v-model="selectedCategory" > Primers </label>
        <label><input type="radio" value="Cejas" v-model="selectedCategory" > Cejas </label>
        <label><input type="radio" value="Rostro" v-model="selectedCategory" > Rostro </label>
        <label><input type="radio" value="Ojos" v-model="selectedCategory" > Ojos </label>
        <label><input type="radio" value="Tools" v-model="selectedCategory" > Tools </label>
      </div>
      <!-- GAMAS -->
      <div class="filter-section">
        <h4 class="h4" >GAMAS</h4>
        <label><input type="radio" value="Todas" v-model="selectedGama" > Todas </label>
        <label><input type="radio" value="Media" v-model="selectedGama" > Media </label>
        <label><input type="radio" value="Media Alta" v-model="selectedGama" > Media-Alta </label>
        <label><input type="radio" value="Alta" v-model="selectedGama" > Alta </label>
        <label><input type="radio" value="Lujo" v-model="selectedGama" > De Lujo </label>
      </div>
      <!-- DISPO -->
      <div class="filter-section">
        <h4 class="h4" >DISPONIBILIDAD</h4>
        <label><input type="radio" value="inStock" v-model="stockFilter"> Stock </label>
        <label><input type="radio" value="outStock" v-model="stockFilter"> Pre-orden</label>
      </div>
    </aside>

    <main class="catalog-content mobile-category-wrapper ">
      <div class="contenedor-grid">
        <div class="columna">
          <div class="mobile-filters-top">
            <button class="mobile-category-button" @click="filtersOpen = !filtersOpen" :aria-expanded="filtersOpen" > 
              <span class="category-button-left"> <!--<span class="category-hamburger">☰</span> -->
                <span class="pCategory">Categorías</span> 
              </span>
              <span class="category-button-right"> 
                <span v-if="selectedCategory !== 'Todos'" class="selected-category-name"> -- {{ selectedCategory }} </span> 
                <span class="category-chevron" :class="{ open: filtersOpen }"> ⌄ </span> 
              </span> 
            </button>

            <!-- Dropdown cel --> 
            <transition name="category-dropdown"> 
              <div v-if="filtersOpen" class="mobile-category-dropdown"> 
                <div class="category-dropdown-header"> 
                  <span> </span> 
                  <button class="category-dropdown-close" @click="closeMobileFilters" aria-label="Cerrar categorías" > X </button> 
                </div>  
                <div class="mobile-category-chips"> 
                  <button v-for="category in categories" :key="category" type="button" class="mobile-category-chip" :class="{ active: selectedCategory === category }" @click="selectMobileCategory(category)" > {{ category }} </button> 
                </div>  
                <!--GAMAS-->
                <div class="mobile-stock-section"> 
                  <span class="stock-title"> Gamas </span> 
                    <div class="mobile-stock-chips"> 
                      <button type="button" class="mobile-category-chip" :class="{ active: selectedGama === 'Todas' }" @click="selectedGama = 'Todas'" > 
                        Todas
                      </button> 
                      <button type="button" class="mobile-category-chip" :class="{ active: selectedGama === 'Media' }" @click="selectedGama = 'Media'" > 
                        Media
                      </button> 
                      <button type="button" class="mobile-category-chip" :class="{ active: selectedGama === 'Media Alta' }" @click="selectedGama = 'Media Alta'" > 
                        Media Alta
                      </button> 
                      <button type="button" class="mobile-category-chip" :class="{ active: selectedGama === 'Alta' }" @click="selectedGama = 'Alta'" > 
                        Alta
                      </button> 
                      <button type="button" class="mobile-category-chip" :class="{ active: selectedGama === 'Lujo' }" @click="selectedGama = 'Lujo'" > 
                        Lujo
                      </button> 
                    </div> 
                </div> 
                <!--DISPO-->
                <div class="mobile-stock-section"> 
                  <span class="stock-title"> Disponibilidad </span> 
                    <div class="mobile-stock-chips"> 
                      <button type="button" class="mobile-category-chip" :class="{ active: stockFilter === 'all' }" @click="stockFilter = 'all'" > 
                        Todos
                      </button> 
                      <button type="button" class="mobile-category-chip" :class="{ active: stockFilter === 'inStock' }" @click="stockFilter = 'inStock'" > 
                        En stock 
                      </button> 
                      <button type="button" class="mobile-category-chip" :class="{ active: stockFilter === 'outStock' }" @click="stockFilter = 'outStock'" > 
                        Pre-orden 
                      </button> 
                    </div> 
                </div> 

                <div v-if="selectedCategory !== 'Todos' || selectedGama !== 'Todas' || stockFilter !== 'all'" class="mobile-category-footer" > 
                  <button type="button" class="mobile-clear-button" @click="clearFilters" > 
                    Limpiar filtros 
                  </button> 
                </div> 
              </div> 
            </transition>
          </div>
        </div>
        
        <div class="columna">
          <div class="search-wrapper">
            <div class="search-bar">
              <span class="search-icon"> 🔍 </span>
                <input type="text" v-model="searchQuery" placeholder="¿Qué estas buscando...?" />
                  <button v-if="searchQuery" class="clear-search" type="button" @click="searchQuery = ''" aria-label="Limpiar búsqueda" > × </button> 
            </div>
            <div class="quick-search">
              <p style="font-family:'Magistral_Bold'; color:#7a7a7a; font-size: 14px;" >Busca por:</p>
                <button @click="searchQuery='Rare Beauty'"> Rare Beauty </button>
                <button @click="searchQuery='Mini'"> Mini </button>
                <button @click="searchQuery='Rubores'"> Rubores </button>
                <button @click="searchQuery='Lip Oil'"> Lip Oil </button>
                <button @click="searchQuery='Media Alta'"> Gama Media-Alta </button>
                <button @click="searchQuery='Lujo'"> Lujo </button>
            </div>
          </div>
        </div>
      </div>

      <div class="toolbar">
        <p> Mostrando {{ (currentPage - 1) * productsPerPage + 1 }} -
            {{ Math.min( currentPage * productsPerPage, filteredProducts.length) }}
            de {{ filteredProducts.length }} productos
        </p> 
        
        <div class="sort">
          <p class="titSort">Ordenar por:</p>
            <select v-model="sortOption">
              <option value="Todos">Todos</option>
              <option value="Menor Precio">Menor Precio</option>
              <option value="Mayor Precio">Mayor Precio</option>
            </select>
        </div>
      </div>

      <!-- GRID Y CARDS -->
      <div class="product-grid">
        <div class="card-catal" v-for="product in paginatedProducts" :key="`${product.id}-${sortOption}`" >
          
          <!-- CHIP DE STOCK -->
          <span class="badge stock" :class="{ out: selectedShade[product.id]
            ? !selectedShadeStock[product.id] : !product.stock }" >
              {{ selectedShade[product.id]
                  ?( selectedShadeStock[product.id]
                    ? 'Stock' : 'Bajo Pedido')
                  :( product.stock
                    ? 'Disponible' : 'Pre-orden')
              }}
          </span>

          <!-- GALERÍA DE IMÁGENES -->
          <div class="product-gallery">
            <img class="main-product-image" :src=" activeView[product.id] === 'swatch'
                ? selectedSwatchImages[product.id]
                : selectedImages[product.id] || product.image " :alt="product.name" />
            <div v-if="selectedShade[product.id]" class="gallery-thumbs">
              <img class="thumb" :class="{ active: activeView[product.id] !== 'swatch' }" :src="selectedImages[product.id]"
                  @click="activeView[product.id] = 'product'" />
              <img class="thumb" :class="{ active: activeView[product.id] === 'swatch' }" :src="selectedSwatchImages[product.id]"
                  @click="activeView[product.id] = 'swatch'" />
            </div>
          </div>

          <!-- ENCABEZADO DE LA CARD -->
            <div class="card-content">
              <small class="category"> {{ product.brand }} </small>
                <div class="title-row">
                  <h3> {{ product.name }}</h3>
                  <!--<span class="rating"> ⭐ {{ product.rating }} </span> -->
                  <span class="price"> ${{ product.price }} </span>
                </div>
            <div>
        </div>
      </div>

            <!-- <div class="price-row">
              <span class="old-price">
                ${{ product.oldPrice }}
              </span>
            </div> -->

            <div v-if="product.shades?.length" class="shade-wrapper" >
              <div class="shade-container"> 
              
              <span v-for="shade in product.shades" :key="shade.name" class="shade"
                :style="{ backgroundColor: shade.color }"
                :class="{ soldOut: !shade.stock, 
                  active: selectedShade [
                    product.id ] === shade.name
                }"
                :title="shade.name"
                
                @click="
                  selectedImages[product.id] = shade.image,
                  selectedSwatchImages[product.id] = shade.swatchImage,
                  selectedShade[product.id] = shade.name,
                  selectedShadeColor[product.id] = shade.color,
                  selectedShadeStock[product.id] = shade.stock,
                  activateView[product.id] = 'product' ">
              </span> 
            </div> 
          </div>
          
          <div class="shade-info">
              <p class="shade-count">
                {{ product.shades.length }} tonos disponibles
              </p>

              <p v-if=" selectedShade[product.id]" class="selected-shade">
                Tono: <span :style="{color: selectedShadeColor[product.id]}"> {{ selectedShade[product.id] }} </span>
                <small :class="{ preorderText: !selectedShadeStock [product.id]}">
                  {{ selectedShadeStock [product.id]
                  ? ' '
                  : '' }}
                </small>
              </p>
          </div>
            
          <div class="title-row">
            <p class="shade-count" > Formato:  <span style="font-weight: 600;">{{ product.formato }} </span> </p>
            <p class="shade-count"> Tamaño: <span style="font-weight: 600;"> {{ product.tam }} </span> </p> 
          </div>
          
          <!--
          <p class="stock" :class="{ out: !product.stock }" >
            {{ product.stock
                  ? 'Stock'
                  : 'Pre-ordena'
            }}
          </p> -->

        <button @click="addToCart(product)">
      Agregar al carrito
    </button>
        

        </div>
      </div>


      <div class="pagination">
        <button @click="prevPage" :disabled="currentPage === 1" > </button>
        <button v-for="page in totalPages" :key="page" @click="currentPage = page"
            :class="{ active: currentPage === page }">
          {{ page }} </button>
        <button @click="nextPage" :disabled="currentPage === totalPages" style="font-weight:600;">
          ❯
        </button>
      </div>
    </main>
  </section>

  <section style="padding-top: 0px;">
    <Footer />
  </section>

</template>


<script setup>
import '@/styles/catalogo.css'
import { computed, ref, watch } from 'vue'
import { products } from '@/data/maquillaje';

import BtnFlotWA from '@/components/BtnFlotWA.vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

import { useCart } from '@/components/composables/cartStore';



const phoneNumber = '522283616313'
const selectedCategory = ref('Todos')
const stockFilter = ref('all')
const selectedImages = ref({})
const selectedShade = ref({})
const selectedShadeColor = ref ({})
const selectedShadeStock = ref ({})
const selectedSwatchImages = ref({})
const activeView = ref({})
const selectedRange = ref('Todas')
const selectedGama = ref('Todas')

//categorias
const categories = [
  'Todos',
  'Lippies',
  'Rubores',
  'Correctores',
  'Fijadores',
  'Bases',
  'Iluminadores',
  'Bronzers',
  'Contornos',
  'Primers',
  'Cejas',
  'Rostro',
  'Ojos',
  'Tools',
]

//Paginacion
const currentPage = ref(1)
const productsPerPage = 21
//Sort
const sortOption = ref('Todos')

//Hacer pedido
const makeOrder = (product) => {
  const selectedShadeName = selectedShade.value[product.id]
  const shadeStock = selectedShadeStock.value[product.id]
  const orderType = selectedShadeName
    ? (shadeStock
        ?'pedido' : 'Pre-orden')
    : ( product.stock
      ? 'pedido' : 'preordenaaa'
    )

    const message = selectedShadeName
      ? `Hola, me interesa hacer una ${orderType} de:
          🛍 Producto: ${product.name}
          🏷 Marca: ${product.brand}
          💄 Tono: ${selectedShadeName}`
      : `Hola, me interesa hacer una ${orderType} de:
          🛍 Producto: ${product.name}
          🏷 Marca: ${product.brand}`
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
      window.open(url, '_blank')
}

//Buscador 
  //if(searchQuery.value.trim()){
    //const search = searchQuery.value.toLowerCase()
    //  filtered = filtered.filter( product =>
    //    product.name.toLowerCase().includes(search) ||
    //    product.brand.toLowerCase().includes(search) ||
    //    product.category.toLowerCase().includes(search) ||
    //    product.shades?.some(shade =>
    //      shade.name.toLowerCase().includes(search)
    //    )
    //  )
  //}

  const searchQuery = ref('') 

  //filtrado de productos
  const filteredProducts = computed ( () => {
  let filtered = [...products]

  const search = searchQuery.value.toLowerCase().trim()
  const words = search.split(/\s+/)
    filtered = filtered.filter(product => {
    const searchableText = [ 
      product.name, 
      product.brand, 
      product.category,
      product.gama,
      ...(product.shades?.map(shade => shade.name) || [])
    ].join(' ').toLowerCase()
    return words.every(word => searchableText.includes(word))
    })



  /*Categoria*/
  if (selectedCategory.value !== 'Todos' && !searchQuery.value.trim())
  {
    filtered = filtered.filter( 
      product => product.category === selectedCategory.value )
  } 
  /*Gamas*/
if (selectedGama.value !== 'Todas') {
  filtered = filtered.filter(
    product =>
      product.gama === selectedGama.value
  )
}


  //stock
  if(stockFilter.value === 'inStock'){
    filtered = filtered.filter( product => product.stock )
  }
  if(stockFilter.value === 'outStock'){
    filtered = filtered.filter( product => !product.stock)
  }
  //Sort
  if (sortOption.value === 'Menor Precio') {
    filtered.sort((a, b) => a.price - b.price)
  }
  if (sortOption.value === 'Mayor Precio') {
    filtered.sort((a, b) => b.price - a.price)
  }
  return filtered
})

watch(selectedCategory, () => {
  if (filtersOpen.value) {
    filtersOpen.value = false
  }
})
//---==================MOBILE FILTERS
const filtersOpen = ref(false)

const closeMobileFilters = () => {
  filtersOpen.value = false
}

const selectMobileCategory = (category) => {
  selectedCategory.value = category
  searchQuery.value ='' 
  filtersOpen.value = false
}

watch(selectedCategory, () => {
  searchQuery.value = ''
  currentPage.value = 1
  if (filtersOpen.value) {
    filtersOpen.value = false
  }
})

watch(searchQuery, (value) => {
  if (value.trim()) {
    selectedCategory.value = 'Todos'
  }
})

watch(selectedCategory, (value) => {
  if (value !== 'Todos') {
    searchQuery.value = ''
  }
})


const activeFiltersCount = computed(() => {
  let count = 0
  if (selectedCategory.value !== 'Todos') count++ 
  if (stockFilter.value !== 'all') count++
  return count
})

const clearFilters = () => {
  selectedCategory.value = 'Todos'
  selectedGama.value = 'Todas'
  stockFilter.value = 'all'
}

//-----
const totalPages = computed(() => {
  return Math.ceil(
    filteredProducts.value.length / productsPerPage
  )
})

const paginatedProducts = computed(() => {
  const start =
    (currentPage.value - 1) * productsPerPage

  return filteredProducts.value.slice(
    start,
    start + productsPerPage
  )
})

watch(
  [selectedCategory, stockFilter, sortOption],
  () => {
    currentPage.value = 1
  }
)

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++
  }
}

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--
  }
}


const props = defineProps({
  product: {
    type: Object,
    required: true
  }
});

const { addToCart } = useCart();



// En ProductCard.vue
const handleAdd = () => {
  // Verificamos que los datos estén bien estructurados antes de enviarlos
  const formattedProduct = {
    id: props.product.id || props.product._id,
    name: props.product.name || props.product.title,
    price: Number(props.product.price || props.product.precio)
  };
  
  addToCart(formattedProduct);
};






</script>